PageApp.Ent.HomePage = Backbone.Model.extend({
  defaults: {
  }
})
